module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/sash-window/sash-window.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/sash-window/sash-window.mtl
// module id = 487
// module chunks = 0